import React from 'react';
import sprintf from 'sprintf';
import SMUserResource from 'resources/SMUserResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';

class SMOSearchAdminUserView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      searchResults: null,
    };
  }
  
  componentDidMount() {
    $(".form-casette__close").on("click", ()=>{
      $(document).trigger("SMHideDialog");
    });
  }
  
  addAdminFormDidSubmit(e){
    e.preventDefault();
    this.props.delegate.addAdminFormDidSubmit(this.state.searchResults[0]);
    $(document).trigger("SMHideDialog");
  }
  
  searchUserFormDidSubmit(e){
    e.preventDefault();
    const ignoreUserIds = this.props.owner.owners_users.map(function(user) { return user.user_id; }).join();
    SMUserResource.getUsers({email: this.refs.inputEmail.value, ignore: ignoreUserIds}, (data, error, xhr)=>{
      if (xhr.status == 200) {
        this.setState({searchResults: data});
      } else if (xhr.status == 404) {
        this.setState({searchResults: []});
      } else {
      }
    });
  }
  
  renderSearchResults() {
    if (this.state.searchResults == null) {
      return null;
    } else if (this.state.searchResults.length == 0) {
      return(
        <div>
          <p className="ta-c mb10">ホストがみつかりませんでした。</p>
          <p className="ta-c mb40"><a href={"mailto:"+this.refs.inputEmail.value+
            '?subject='+sprintf(I18n.t('dashboard.label_000125'), this.props.owner.name)+
            '&body='+sprintf(I18n.t('dashboard.text_000023'), this.props.owner.name, this.props.owner.name)
          }>「{this.refs.inputEmail.value}」に招待メールを送信する</a></p>
        </div>
      );
    } else {
      return(
        <div className="form-casette form-user-box mb80">
          <form onSubmit={this.addAdminFormDidSubmit.bind(this)}>
            <a href={Routes.user_path(this.state.searchResults[0].username)}><img src={this.state.searchResults[0].profile_image} alt="" className="form-user-box__img" /></a>
            <SMFormSubmitButton name='add'
              title={I18n.t("dashboard.label_000123")} 
              options={{className: "button-gray mt15 pt10 pb10 w110 fr"}} />
            <p className="form-user-box__name"><a href={Routes.user_path(this.state.searchResults[0].username)}>{this.state.searchResults[0].name}</a></p>
          </form>
        </div>
      );
    }
  }
  
  render() {
    return (
      <div className="form-casette maincol-lightbox__form">
        <h2 className="dashboard-title mb20">
          ホストを追加
          <span className="dashboard-title__supplement ml15">
            登録メールアドレスからホストを追加できます。メールアドレスを入力してください。
          </span>
        </h2>
        <div className="form-box">
          <form onSubmit={this.searchUserFormDidSubmit.bind(this)}>
            <input ref="inputEmail" type="text" className="form-text w400 mr10" placeholder="example@spacemarket.co.jp" />
            <SMFormSubmitButton name='search'
              title={I18n.t("dashboard.label_000124")} 
              options={{className: "button-blue pt10 pb10 w70"}} />
          </form>
        </div>
        {this.renderSearchResults()}
        <a href="#" className="form-casette__close"><i className="fa fa-times"></i></a>
      </div>
    );
  }
}
export default SMOSearchAdminUserView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSearchAdminUserView.jsx